import PropTypes from 'prop-types';
import React from 'react';
import {Card, CardHeader} from '@material-ui/core';
import {grey} from '@material-ui/core/colors';

function ImportedProjectToolbar(props) {
  const dateOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };
  const {importedProject, projectMilestones, completedEstimate} = props;

  return (
    <Card style={{backgroundColor: grey[100]}}>
      <CardHeader
        title={importedProject.cnsObject.name}
        subheader={
          projectMilestones.length > 0
            ? `Estimated Completion: ${new Date(completedEstimate).toLocaleDateString(
                'en-AU',
                dateOptions,
              )}`
            : ''
        }
      />
    </Card>
  );
}

ImportedProjectToolbar.propTypes = {
  importedProject: PropTypes.object.isRequired,
  projectMilestones: PropTypes.array.isRequired,
  completedEstimate: PropTypes.number.isRequired,
};

export default ImportedProjectToolbar;
